/**
 * Slider Component
 *
 * @file slider.js
 */

import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
SwiperCore.use([Navigation, Pagination]);

import 'swiper/swiper-bundle.css';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    const swiper = new Swiper('.main-slider', {
      pagination: {
        el: '.swiper-pagination',
      },
    });
  };

  const homeNewsSlider = () => {
    const swiperNews = new Swiper('.home-news-carousel', {
      spaceBetween: 30,
      slidesPerView: 2,
      loop:true,
      navigation: {
        nextEl: '.home-news-next',
        prevEl: '.home-news-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      },
    });
  }

  const init = () => {
    fullSlider();
    homeNewsSlider();
  };

  return {
    init,
  };
})();

export default slider;
